namespace advisorop.components.advisor {

    class AdvisorListWrapperController {

        $router;
        public model: domains.IAdvisor;
        rolesNames: any;
        
        advisors: Array<domains.IAdvisor>;
        currentAdvisor: domains.IAdvisor;
        companyGroupIdCurrentAdvisor: number;
        public selectedAdvisor: domains.IAdvisor;
        selectedAdvisorId: number;
        selectedCompanyGroup: domains.ICompanyGroup;

        static $inject = ["identityService","generalService"];
        constructor(private identityService: services.IdentityService,
             private generalService: services.GeneralService) {                        
        }

        advisorSelected(advisor: domains.IAdvisor): void {
            this.selectedAdvisor = advisor;
            this.selectedAdvisorId = this.selectedAdvisor.id;
            //console.log(this.selectedAdvisor.lastName);
            //console.log(this.selectedAdvisor.id);

        };
        
        $onInit(): void {
            this.identityService.getUserPromise()
                .then(response => {
                    this.companyGroupIdCurrentAdvisor = response.advisor.companyGroup.id;
                });
        }

        $routerOnActivate(next, previous) {
        }
    }

 
    class AdvisorListWrapper implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = AdvisorListWrapperController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/advisor-list-wrapper.html';
        }
    }
    angular.module(Constants.APP).component("advisorListWrapper", new AdvisorListWrapper());
}